// filepath: apps/web/src/features/admin/audit/AuditPagination.tsx
//
// FR-UI-ADM-14 — Previous / Next cursor pagination.
//
// AL-11: "next page" sends ?cursor=<pagination.cursor>.
// AL-12: has_more=false disables the Next button.

import { useTranslation } from "@/i18n/useTranslation";
import type { AuditFilterState } from "./types";

export interface AuditPaginationProps {
  filter: AuditFilterState;
  hasMore: boolean;
  onChange: (next: AuditFilterState) => void;
}

export function AuditPagination({
  filter,
  hasMore,
  onChange,
}: AuditPaginationProps) {
  const { t } = useTranslation();
  const hasPrev = filter.cursor !== null;
  return (
    <nav className="audit-pagination" aria-label={t("audit.pagination.label")}>
      <button
        type="button"
        disabled={!hasPrev}
        aria-disabled={!hasPrev}
        onClick={() => onChange({ ...filter, cursor: null })}
      >
        {t("audit.pagination.previous")}
      </button>
      <button
        type="button"
        disabled={!hasMore}
        aria-disabled={!hasMore}
        onClick={() => {
          // Next click advances by setting cursor to the response's pagination.cursor.
          // The parent component supplies the new cursor via onChange in its fetch handler.
        }}
        data-needs-cursor="true"
      >
        {t("audit.pagination.next")}
      </button>
    </nav>
  );
}
